export default __webpack_public_path__ + "media/images/elements/02-9bee5b16cc644a749171a9d585d461be.png";